import { render, staticRenderFns } from "./QuestionDetails.vue?vue&type=template&id=6adf0a7e"
import script from "./QuestionDetails.vue?vue&type=script&lang=js"
export * from "./QuestionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports